import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import PartnerSharesHeader from './components/PartnerSharesHeader';
import PartnerSharesBody from './components/PartnerSharesBody';
import { usePartnerShares } from './context/PartnerSharesContext';

const PartnerShares: FC = () => {
  const { data } = usePartnerShares();
  return (
    <>
      <PartnerSharesHeader />
      <PartnerSharesBody />

      {data.isLoading && <CustomLoading />}
    </>
  );
};
export default PartnerShares;
